import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.STUDENT = function (state, payload) {
  state.student = payload
}
mutations.FIND_STUDENT = function (state, payload) {
  state.student = payload
}
const state = {
  rows: [],
  student: [],
  row: null,
  condition: {},
  loading: false
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0403ClassStudent cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0403ClassStudent search')
    return client.postData({ data: { search: { api: 'M0403ClassStudentService.findDataDetails', input: condition } } })
      .then((data) => {
        const output = data.search.output
        SysUtils.showInfo(`Class has ${output.length} student(s) available`)
        commit('FIND_STUDENT', output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0403ClassStudent add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0403ClassStudent edit')
    return client.postData({ data: { find: { api: 'M0403ClassStudentService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0403ClassStudent delete')
    return client.postData({ data: { delete: { api: 'M0403ClassStudentService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0403ClassStudent save')
    return client.postData({ data: { save: { api: 'M0403ClassStudentService.saveDataDetails', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  email: ({ commit, state }, row) => {
    console.debug('called M0403ClassStudent save')
    state.loading = true
    return client.postData({ data: { student: { api: 'M0403ClassStudentService.saveEmail', input: row } } })
      .then((data) => {
        state.loading = false
        commit('STUDENT', data.student.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0403ClassStudent download')
    return client.download({ data: { download: { api: 'M0403ClassStudentService.downloadData', input: condition } } })
  },
  removeStudentFromClass: ({ commit }, condition) => {
    console.debug('called M0403ClassStudent deleteStudentFromClass')
    return client.postData({ data: { remove: { api: 'M0403ClassStudentService.deleteStudentFromClass', input: condition } } })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module



// WEBPACK FOOTER //
// ./src/components/functions/M0403ClassStudent/M0403ClassStudentStore.js